const notificationPreferencesAction = {
    BACKUP : 'backup',

    NEW_EMAIL : 'New Email',

    NEW_POPUP : 'New Popup',

    SAVE : 'save',

    DISCARD : 'discard',

    DELETE : 'delete'

};

angular.module('gw-um-j2js')
    .constant('notificationPreferencesAction', notificationPreferencesAction);